module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAARCAYAAAAL4VbbAAAAAXNSR0IArs4c6QAAAU1JREFUOE910r9Kw1AUx/HvSUShOgg6CV1cFBEqLkIXce4QHNQ9r+EjOPkCDoUMir6AV7CbKAVBXHTpIkSpii1IxTY9cpP0n2nvEnL4/M65B66QHlXdBu5EpNWr/f+KLXRUd0U5VaESgpefEJBmUxclRw2YSzuZrxAvn89OiDuHP1oS4QKYiQOCab9lAzG25/lbSzAIKJiPT7zi0IQ+toFqQ0vdoQBgOs1BYATbgKmnAUmvBKbRwtvPSyuDbeAsTAKa7qCCeW3jjceqbv0Fg7IT7ytEUy6lDN5TdddrBA4c9KAo/uGylEewhUtPBI4kENtR8Y9WpJz8psfC2UcCGYIi+CdrCexjC3/vCRwn7QiRK/jnhQGMsYXv1aHREImDf7U5CmO8ca3zMzkqQAGIHPBvtrKwf43VW12Y7nKJcvxQHA9HFkTVRSSa9JZt/Q8oWoFRIhJ26gAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./static/img/titleArrowImg.png
// module id = DzYZ
// module chunks = 1